// extracted by mini-css-extract-plugin
export default {"video_box":"index_video_box_x8ZJB","video":"index_video_-mASr"};